"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useIsCurrentLocation = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useIsCurrentLocation"));

var _executeScript = _interopRequireDefault(require("./utils/executeScript"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ReactHTML02 = function ReactHTML02(_ref) {
  var externalScript = _ref.externalScript,
      html = _ref.html,
      id = _ref.id,
      script = _ref.script;
  var isCurrentLocation = (0, _useIsCurrentLocation.default)();
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _window$scriptLoaded;

    if (!isCurrentLocation) return;
    var current = ref.current;

    if (externalScript) {
      var documentFragment = document.createRange().createContextualFragment(externalScript);
      current.appendChild(documentFragment);
    }

    if (script) {
      (0, _executeScript.default)(script);
    }

    var scriptLoaded = (_window$scriptLoaded = window.scriptLoaded) === null || _window$scriptLoaded === void 0 ? void 0 : _window$scriptLoaded[id];

    if (scriptLoaded) {
      window.location.reload();
    } else {
      setLoaded(id);
    }

    return function () {
      current.textContent = "";
    };
  }, [externalScript, id, isCurrentLocation, script]);

  var setLoaded = function setLoaded(identifier) {
    window.scriptLoaded = window.scriptLoaded || {};
    window.scriptLoaded[identifier] = true;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-html-02",
    dangerouslySetInnerHTML: {
      __html: html
    },
    ref: ref
  });
};

ReactHTML02.propTypes = {
  externalScript: _propTypes.default.string,
  html: _propTypes.default.string,
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  script: _propTypes.default.string
};
var _default = ReactHTML02;
exports.default = _default;